module.exports = __webpack_public_path__ + "static/media/history_title.55684b1a.png";